import styled from 'styled-components';
import { color, space, textAlign, SpaceProps, ColorProps, TextAlignProps } from 'styled-system';
import { ThemeInterface } from '../theme/ThemeInterface';

interface LabelProps extends ColorProps, TextAlignProps, SpaceProps, ThemeInterface {
  isWeb?: boolean;
  mt?: any;
  pr?: any;
  ml?: any;
}

const Label = styled.label<LabelProps>`
  ${space}
  ${color}
  ${textAlign}
  font-weight: ${props => (!props.isWeb ? 100 : undefined)};
  font-size: ${props => (props.isWeb ? props.theme.fontSize[0] : '0.8em')};
  font-family: ${props => props.theme.fontFamily};
  letter-spacing: ${props => (!props.isWeb ? '1.1px' : undefined)};
  margin-bottom: ${props => (props.isWeb ? String(props.marginBottom) : '5px')};
`;

export default Label;

Label.defaultProps = {
  // mb: 2,
  color: 'primary',
};
